import { render, staticRenderFns } from "./company-department-dialog.vue?vue&type=template&id=06499eb3&"
import script from "./company-department-dialog.vue?vue&type=script&lang=js&"
export * from "./company-department-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "company-department-dialog.vue"
export default component.exports